export default __webpack_public_path__ + "static/media/consulting-icon.58ff9e96.svg";